module.exports = __webpack_public_path__ + "static/media/Conference-Home_Icon.6aa552d5.svg";